import React, { useEffect, useState } from 'react'
import CustomRow from '../../../reusable-components/CustomRow'
import { Col } from 'antd'
import AgiliteSkeleton from '../../../reusable-components/AgiliteSkeleton'
import { readClinicDataPoints } from '../../../Super-Admin/Data Points/data-points-utils/data-point-utils'
import { readCarePlanTemplates } from '../../Chronic Care Plans/utils/utils'
import store from '../../../../store'
import PatientEnrollment from '../../Common/PatientEnrollment'
import TreatmentPlansList from './TreatmentPlansList'

const TreatmentPlansManagement = ({ isMonitoring }) => {
  // State
  const [planTemplatesLoading, setPlanTemplatesLoading] = useState(false)
  const [currentTemplate, setCurrentTemplate] = useState(null)
  const [dataPoints, setDataPoints] = useState([])

  // Loading
  const [planTemplates, setPlanTemplates] = useState([])
  const [dataPointsLoading, setDataPointsLoading] = useState(false)

  useEffect(() => {
    handleReadPlanTemplates()
    handleReadDataPoints()
    // eslint-disable-next-line
  }, [])

  const handleReadDataPoints = async () => {
    let tmpDataPoints = []

    setDataPointsLoading(true)
    try {
      tmpDataPoints = await readClinicDataPoints()
      setDataPoints(tmpDataPoints)
    } catch (e) {}
    setDataPointsLoading(false)
  }

  const handleReadPlanTemplates = async () => {
    let tmpData = []

    setPlanTemplatesLoading(true)
    try {
      tmpData = await readCarePlanTemplates({
        createdBy: store.getState().auth.agiliteUser._id,
        planType: 'treatment'
      })

      setPlanTemplates(tmpData)
    } catch (e) {}
    setPlanTemplatesLoading(false)
  }

  const handleEnrollmentView = (templateProps) => {
    setCurrentTemplate(templateProps)
  }

  return (
    <>
      <CustomRow>
        {dataPointsLoading || planTemplatesLoading ? (
          <Col span={24}>
            <AgiliteSkeleton skActive spinnerTip='Loading...' />
          </Col>
        ) : (
          <Col span={24}>
            {!currentTemplate ? (
              <TreatmentPlansList
                isMonitoring={isMonitoring}
                handleEnrollmentView={handleEnrollmentView}
                dataPoints={dataPoints}
                planTemplates={planTemplates}
                refreshView={handleReadPlanTemplates}
              />
            ) : undefined}
            {currentTemplate ? (
              <PatientEnrollment
                isMonitoring={isMonitoring}
                setCurrentTemplate={setCurrentTemplate}
                template={currentTemplate}
                planType='treatment'
                planLabel='Treatment Plan'
              />
            ) : undefined}
          </Col>
        )}
      </CustomRow>
    </>
  )
}

export default TreatmentPlansManagement
